export default __webpack_public_path__ + "static/media/IconStalled.dcda55be.png";